"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureCorrectBlockProps = exports.blockAsLazy = void 0;
var react_1 = __importStar(require("react"));
var kameleon_block_helpers_1 = require("./kameleon-block-helpers");
var lib_1 = require("@kameleon-core/lib");
var lodash_1 = require("lodash");
/**
 * The onLoad method is there as a callback to overwrite the default props whenever the actual KameleonElement is resolved
 * and known. A custom handler can be provided to overwrite the default props merged i
 *
 *
 * @param element
 * @param onLoad
 */
var blockAsLazy = function (element, onLoad) {
    if (typeof element !== "string") {
        return (0, react_1.lazy)(function () {
            var _a, _b;
            var component = element.component;
            component.defaultProps = (0, lib_1.getDefaultProps)(element);
            var initialProps = {};
            if (onLoad) {
                var defaultProps = (0, lib_1.getDefaultProps)(element);
                var loadProps = (_a = onLoad(element, defaultProps)) !== null && _a !== void 0 ? _a : {};
                initialProps = Object.assign(defaultProps, loadProps, {
                    layoutProps: (0, lodash_1.merge)({}, defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.layoutProps, (_b = loadProps === null || loadProps === void 0 ? void 0 : loadProps.layoutProps) !== null && _b !== void 0 ? _b : {}),
                });
            }
            // eslint-disable-next-line no-promise-executor-return
            // Always pass the new props so props can be updated after rendering!
            return new Promise(function (r) {
                return r({
                    default: function (props) {
                        return react_1.default.createElement(component, __assign(__assign({}, initialProps), (props !== null && props !== void 0 ? props : {})));
                    },
                });
            });
        });
    }
    return (0, react_1.lazy)(function () {
        return (0, kameleon_block_helpers_1.findBlockByPackageName)(element).then(function (blockElement) {
            var _a, _b;
            if (!blockElement)
                return { default: function () { return null; } };
            var component = blockElement.component;
            component.defaultProps = (0, lib_1.getDefaultProps)(blockElement);
            var inputProps = {};
            if (onLoad) {
                var defaultProps = (0, lib_1.getDefaultProps)(blockElement);
                var loadProps = (_a = onLoad(blockElement, defaultProps)) !== null && _a !== void 0 ? _a : {};
                inputProps = Object.assign(defaultProps, loadProps, {
                    layoutProps: (0, lodash_1.merge)({}, defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.layoutProps, (_b = loadProps === null || loadProps === void 0 ? void 0 : loadProps.layoutProps) !== null && _b !== void 0 ? _b : {}),
                });
            }
            // Always pass the new props so props can be updated after rendering!
            return {
                default: function (props) {
                    return react_1.default.createElement(component, __assign(__assign({}, inputProps), (props !== null && props !== void 0 ? props : {})));
                },
            };
        });
    });
};
exports.blockAsLazy = blockAsLazy;
/**
 * Correct the inputProps to match the actualProps (containing defaultProps as well) types.
 * This means for example, that if a certain prop should be an array, but is provided as an empty string,
 * it will be corrected to an empty array.
 *
 * There is one case of which the defaultProps will be enforced:
 * - ALL props are unset OR empty strings. In this case we assume the defaultProps should be rendered.
 * - If at least one prop is not empty, all the other props that ARE empty, are enforced to the empty value of its
 *   corresponding type.
 *
 * @param inputProps The inputProps actually provider to the component to be rendered.
 * @param actualProps The actualProps after lazy loading is applied, mixed with defaultProps, representing correct types as well.
 * @param mergeDefault
 */
var ensureCorrectBlockProps = function (inputProps, actualProps, mergeDefault) {
    var _a;
    if (mergeDefault === void 0) { mergeDefault = false; }
    if (!(typeof inputProps === "object" && inputProps !== null)) {
        inputProps = {}; // Force empty object in case of inputProps are not an object
    }
    var allPropsAreEmpty = true;
    var blockProps = {};
    for (var _i = 0, _b = Object.entries(actualProps); _i < _b.length; _i++) {
        var _c = _b[_i], prop = _c[0], value = _c[1];
        var hasInputProp = inputProps[prop] !== undefined;
        var propValueToPass = (_a = inputProps[prop]) !== null && _a !== void 0 ? _a : undefined;
        if (!hasInputProp) {
            // If the inputProps does not even contain the prop itself, fallback to defaultProp
            if (mergeDefault) {
                propValueToPass = value;
            }
            else {
                inputProps[prop] = "";
            }
        }
        if (inputProps[prop] === "") {
            // Typeof actualProps value is leading here, since this contain the defaultProps
            // The inputProps may have incorrect value for the matching type (e.g. empty string but is an array)
            if (Array.isArray(value))
                propValueToPass = [];
            else if (typeof value === "boolean")
                propValueToPass = false;
            else if (typeof value === "object")
                propValueToPass = {};
            else if (typeof value === "string")
                propValueToPass = "";
            else if (typeof value === "function")
                propValueToPass = undefined;
            else if (typeof value === "number")
                propValueToPass = 0;
            else
                propValueToPass = undefined;
        }
        // Prop is set and not an empty string, we know for sure that not ALL props are empty now :)
        else {
            allPropsAreEmpty = false;
        }
        blockProps[prop] = propValueToPass;
    }
    // Also apply the missing entries from the inputProps, so they won't miss out.
    // Also, if there was a missing entry, set allPropsAreEmpty false to ensure non-defaults are rendered
    for (var _d = 0, _e = Object.entries(inputProps); _d < _e.length; _d++) {
        var _f = _e[_d], prop = _f[0], value = _f[1];
        if (!(prop in blockProps)) {
            blockProps[prop] = value;
        }
    }
    // If all props are empty string, we assume the block is just being registered in the CMS
    // with empty values, and thus it's safe to fall back to default props.
    return allPropsAreEmpty ? actualProps : blockProps;
};
exports.ensureCorrectBlockProps = ensureCorrectBlockProps;
